<div class="card">
  <h5>HQ List</h5>

  <p-table #dt1 [value]="hqs" dataKey="id" [rows]="20" [responsive]="true" [lazy]="true" [loading]="loading"
    [rowHover]="true" styleClass="p-datatable-gridlines" [paginator]="true"
    [rowsPerPageOptions]="[10, 20, 50, 100]" [totalRecords]="total" (onLazyLoad)="filter($event)"
    responsiveLayout="scroll" [showCurrentPageReport]="true"
    currentPageReportTemplate="[{first} to {last} of {totalRecords} HQs]">
    <ng-template pTemplate="caption">
      <div class="tw-flex tw-justify-between tw-gap-2">
        <span class="p-input-icon-left tw-grow">
          <i class="pi pi-search"></i>
          <input pInputText type="text" #filter (input)="dt1.filter($event.target.value,'query')" placeholder="Search by name or domain"
            class="tw-w-full" />
        </span>
        <button pButton label="Add" class="mr-2" icon="pi pi-plus" [routerLink]="['/hq/add']"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 12rem">Name</th>
        <th style="min-width: 12rem">Domain</th>
        <th style="min-width: 8rem">Published</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-hq>
      <tr>
        <td><strong>{{hq.Name}}</strong></td>
        <td>
          @for (domain of hq.Domains; track $index) {
          <div>
            {{domain}}
            <a href="//{{domain}}{{domain.includes('localhost')? ':4351' : ''}}" target="_blank"
              class="tw-ml-2 tw-text-blue-500" title="Open Website">
              <i class="pi pi-fw pi-external-link"></i>
            </a>
          </div>
          }
          @if(!hq.Domains?.length){
          <span class="tw-text-gray-400">No domain</span>
          }
        </td>
        <td>
          @if(hq.IsPublished){<i class="pi pi-check-circle text-success"></i>}
          @else {<i class="pi pi-times-circle text-danger"></i>}
        </td>
        <td>
          <p-menu #actionMenu [model]="hq._actions" [popup]="true" appendTo="body"></p-menu>
          <button pButton [id]="'action-menu-'+hq.Id" type="button" (click)="actionMenu.toggle($event)"
            icon="pi pi-ellipsis-h"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">No HQ found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="4">Loading HQ data. Please wait.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmPopup key="confirmPopup"></p-confirmPopup>
